<template>
  <div class="kpi-grid">
    <div v-for="item in cards" :key="item.key" class="kpi-card" :style="{ borderTopColor: item.borderColor }">
      <div class="kpi-value" :style="{ color: item.valueColor }">{{ item.value }}</div>
      <div class="kpi-label">{{ item.label }}</div>
      <div class="kpi-subtitle">{{ item.subtitle }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NpsReplicaKpiGrid',
  props: {
    kpis: {
      type: Object,
      default: function () {
        return {
          nps: 0,
          status: 'neutral',
          responses: 0,
          promoters: { count: 0, pct: 0 },
          neutrals: { count: 0, pct: 0 },
          detractors: { count: 0, pct: 0 }
        };
      }
    }
  },
  computed: {
    cards () {
      const npsState = this.npsState(this.kpis.nps);

      return [
        {
          key: 'nps',
          label: 'NPS Total',
          value: this.kpis.nps,
          subtitle: npsState.label,
          borderColor: '#E94560',
          valueColor: '#1A1A2E'
        },
        {
          key: 'promoters',
          label: '% Promotores',
          value: this.formatPct(this.kpis.promoters.pct),
          subtitle: 'Score 9-10',
          borderColor: '#28A745',
          valueColor: '#28A745'
        },
        {
          key: 'neutrals',
          label: '% Neutros',
          value: this.formatPct(this.kpis.neutrals.pct),
          subtitle: 'Score 7-8',
          borderColor: '#FFC107',
          valueColor: '#FFC107'
        },
        {
          key: 'detractors',
          label: '% Detractores',
          value: this.formatPct(this.kpis.detractors.pct),
          subtitle: 'Score 0-6',
          borderColor: '#DC3545',
          valueColor: '#DC3545'
        },
        {
          key: 'responses',
          label: 'Respuestas',
          value: this.kpis.responses,
          subtitle: 'Con NPS',
          borderColor: '#6366F1',
          valueColor: '#6366F1'
        }
      ];
    }
  },
  methods: {
    formatPct (value) {
      return `${Number(value || 0).toFixed(1)}%`;
    },
    npsState (value) {
      if (value >= 50) {
        return { label: 'Excelente', color: '#28A745' };
      }

      if (value >= 20) {
        return { label: 'Bueno', color: '#FFC107' };
      }

      return { label: 'Alerta', color: '#DC3545' };
    }
  }
};
</script>

<style scoped>
.kpi-grid {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(5, 1fr);
}

.kpi-card {
  background: var(--bg-card, #FFFFFF);
  border-radius: 12px;
  border-top: 4px solid #E94560;
  box-shadow: var(--card-shadow, 0 2px 12px rgba(26,26,46,0.08));
  min-height: 132px;
  padding: 20px 22px;
  text-align: center;
}

.kpi-value {
  font-size: 38px;
  font-weight: 800;
  line-height: 1;
  margin-bottom: 6px;
}

.kpi-label {
  color: var(--text-muted, #6B7280);
  font-size: 11px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.kpi-subtitle {
  color: var(--text-muted, #6B7280);
  font-size: 11px;
  margin-top: 4px;
}

@media (max-width: 900px) {
  .kpi-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/client/rounds/nps-dashboard/components/KpiGrid.vue